// extracted by mini-css-extract-plugin
export var container = "_la-0";
export var dotAnimation = "_la-2";
export var dotsLoading = "_la-1";